import React, { useCallback, useState } from 'react';

import { PortalWrapper } from './portal-wrapper';

import { NotificationContext } from './context';
import { NotificationList } from './notification-list';
import { INotification, TShowNotification } from './types';

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [notifications, setNotifications] = useState<INotification[]>([]);

  const showNotification: TShowNotification = ({
    title,
    message,
    isAutoClose,
    timeClose,
  }) => {
    const id = Math.random().toString(36).substr(2, 9);
    setNotifications(prev => [
      ...prev,
      { id, title, message, isAutoClose, timeClose, onClose: () => {} },
    ]);
  };

  const hideNotification = useCallback((id: string) => {
    setNotifications(prev =>
      prev.filter(notification => notification.id !== id)
    );
  }, []);

  return (
    <NotificationContext.Provider
      value={{ notifications, showNotification, hideNotification }}
    >
      {children}
      <PortalWrapper>
        <NotificationList
          notifications={notifications}
          hideNotification={hideNotification}
        />
      </PortalWrapper>
    </NotificationContext.Provider>
  );
};
